module.exports = __webpack_public_path__ + "pl.svg?b4850bf132d644b612dae0ecd20a36cd";